import { PopoverTrigger } from '@chakra-ui/react';
import { GifIcon } from '@mybridge/icons';
import Giphy from '@mybridge/ui/giphy';
import { useDisclosure } from '@mybridge/ui/hooks';
import { IconButton } from '@mybridge/ui/icon-button';
import { Box } from '@mybridge/ui/layout';
import { Popover, PopoverBody, PopoverContent } from '@mybridge/ui/popover';
import { Tooltip } from '@mybridge/ui/tooltip';
import { useContext, useEffect, useState, useRef } from 'react';
import { TeamsContext } from '../teams/context';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Input } from '@mybridge/ui';

export const GifPicker = ({ hideOnSelect = true,setSelectedGif, isDisabled = false, ...props }) => {
  const {
    setGifs,
    gifs,
    images,
    videos,
    chatRoom,
    createTeamChatPosts,
    isMember,
    isOrganizer,
    teamDetails,
  } = useContext(TeamsContext);
  const { t } = useTranslator();
  const { matrixClient } = useContext(MatrixContext);
  const { isOpen, onClose, onToggle } = useDisclosure();

  const [query, setQuery] = useState('')
  const [searched, setSearched] = useState(false)

  const triggerRef = useRef(null);
  const popoverContentRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (!isOpen) return;

      const path =
        (e.composedPath && e.composedPath()) ||
        e.path ||
        (() => {
          const p = [];
          let node = e.target;
          while (node) {
            p.push(node);
            node = node.parentNode;
          }
          return p;
        })();

      if (triggerRef?.current && path.includes(triggerRef.current)) return;
      if (popoverContentRef?.current && path.includes(popoverContentRef.current))
        return;

      onClose();
    };

    document.addEventListener('mouseup', handleDocumentClick);
    return () => {
      document.removeEventListener('mouseup', handleDocumentClick);
    };
  }, [isOpen]);

  const onSelect = (gif) => {
    // setGifs?.([gif])
    setSelectedGif(gif?.images?.original)
    onClose();
  };

  const handleSearch = (e) => {
    const value = e.target.value
    setQuery(value)
    setSearched(value.trim().length > 0) // switch to search if not empty
  }

  return (
    <>
      <Popover isOpen={isOpen} onClose={onClose}>
        <PopoverTrigger>
          <Box ref={triggerRef}>
            <Tooltip rounded={"lg"} variant="round" label={t('myMessages.addGif') || "Add Gif"}>
              <IconButton
                variant="ghost"
                isDisabled={isDisabled || images?.length || videos?.length}
                onClick={onToggle}
                icon={
                  <GifIcon color={props?.color ? props?.color : '#3D5A80'} />
                }
                {...props}
              />
            </Tooltip>
          </Box>
        </PopoverTrigger>
        <PopoverContent ref={popoverContentRef}>
          <PopoverBody>
            {isOpen ? (
              <>
                <Input
                  placeholder="Search for GIFs..."
                  value={query}
                  onChange={handleSearch}
                  mb={6}
                />
                <Giphy
                  searchQuery={query}
                  searched={searched}
                  onSelect={onSelect} 
                //  onLoad={()=>handleGiphyLoaded()}
                />
              </>
            ): ''}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  );
};
